import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { InsightPassengerAddressModel, InsightPassengerModel } from 'src/app/core/models/individual-model';
import { InsightPassengerService } from 'src/app/core/services/individul-services';
import { Select2Data } from 'src/app/shared/ui/forms/inputs/oops-select2';
import { cloneDeep } from 'lodash';

declare var $: any;

@Component({
    selector: 'op-payment-address-type-selection',
    templateUrl: './payment-address-type-selection.component.html'
})
export class PaymentAddressTypeSelectionComponent {
    @Input() set individualId(val: string) {
        this._individualId = val;
        this.fetchData(this._individualId);
    }
    @Input('data')
    set data(value: any) {
        this._value = value;
    }
    @Input() hasError: boolean = false;
    @Input() disabled: boolean = false;
    @Input() isInPayment: boolean = false;

    @Output() dataChange = new EventEmitter<any>();
    @Output() presetSelected = new EventEmitter<InsightPassengerAddressModel>();

    get value(): any {
        return this._value;
    }

    set value(val: any) {
        this._value = val;
    }

    private readonly EMPTY_SELECT2_DATA: Select2Data = {
        id: '',
        text: '',
        selected: false,
        disabled: false
    }

    readonly OPTION = {
        placeholder: "",
        allowClear: false,
        minimumResultsForSearch: -1,
        templateResult: this.template,
        templateSelection: this.selectionTemplate
    }

    select2Datas$ = new BehaviorSubject<Select2Data[]>([]);
    loadCompleted$ = new BehaviorSubject<boolean>(false);

    private _value: any;
    private _individualId: string;

    constructor(private insightPassengerService: InsightPassengerService) {
        this.template = this.template.bind(this);
        this.selectionTemplate = this.selectionTemplate.bind(this);
    }

    ngOnInit(): void {
        this.fetchData(this._individualId);
    }

    public fetchData(individualId: string) {
        if (!individualId) return;
        this.loadCompleted$.next(false);
        this.insightPassengerService.getInsightPassenger(individualId)
            .subscribe(
                (insightPassenger: InsightPassengerModel) => {
                    const insightPassengerSelect2Datas = insightPassenger?.insightPassengerAddresses?.map(item => {
                        let address = item;
                        if (item.useAddressId) {
                            const useAddress = insightPassenger?.insightPassengerAddresses
                                ?.find(a => a.addressId == item.useAddressId);
                            address = cloneDeep(useAddress);
                            address.addressId = item.addressId;
                            address.addressTypeCode = item.addressTypeCode;
                            address.addressTypeName = item.addressTypeName;
                        }
                        return {
                            id: address.addressId,
                            text: address.addressLine1,
                            selected: false,
                            disabled: false,
                            action: address,
                            elementId: address.addressId
                        };
                    }) || [];
                    const combinedSelect2Datas =  [this.EMPTY_SELECT2_DATA,
                        ...insightPassengerSelect2Datas];
                    this.select2Datas$.next(combinedSelect2Datas);
                    this.loadCompleted$.next(true);
                }
            )
    }

    onPresetSelected(item: InsightPassengerAddressModel) {
        this.presetSelected.emit(item);
    }

    onDataChange(value: any) {
        this.dataChange.emit(value);
    }

    private template(state) {
        return $(`
        <div class="d-table-cell" style="min-width: 150px">${state.action?.addressTypeName || state.text}</div>
        <div class="d-table-cell">${state.action?.addressLine1 || ''}</div>
        `);
    }

    private selectionTemplate(state) {
        return $(`
            <div class="d-table-cell" style="min-width: 150px">${state.action?.addressTypeName || state.text}</div>
            `);
    }
}
